// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 256 256%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.9%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27 opacity=%270.04%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --black: #080808;
  --deep: #0d0d0d;
  --panel: #111111;
  --panel2: #141414;
  --border: rgba(255, 255, 255, 0.07);
  --gold: #c9a96e;
  --gold-light: #e8c98a;
  --gold-dim: rgba(201, 169, 110, 0.15);
  --white: #f5f0e8;
  --muted: rgba(245, 240, 232, 0.45);
  --font-display: 'Cormorant Garamond', serif;
  --font-body: 'Syne', sans-serif;
}

*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: smooth;
}

body {
  background: var(--black);
  color: var(--white);
  font-family: var(--font-body);
  overflow-x: hidden;
  cursor: none;
}

a { text-decoration: none; color: inherit; }
ul { list-style: none; }
button { border: none; background: none; font-family: var(--font-body); cursor: none; }
input, textarea { font-family: var(--font-body); }

/* Noise texture overlay */
body::before {
  content: '';
  position: fixed;
  inset: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.38;
  pointer-events: none;
  z-index: 9000;
}

.section-wrapper {
  padding: 130px 80px;
  position: relative;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 90px;
}

.section-num {
  font-family: var(--font-display);
  font-size: 13px;
  color: var(--gold);
  opacity: 0.7;
  letter-spacing: 0.1em;
}

.section-line {
  width: 50px;
  height: 1px;
  background: var(--gold);
  opacity: 0.3;
}

.section-title {
  font-family: var(--font-display);
  font-size: clamp(38px, 5vw, 68px);
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 1;
}

.section-title em {
  font-style: italic;
  color: var(--gold);
}

@media (max-width: 900px) {
  .section-wrapper { padding: 90px 24px; }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,kCAAkC;EAClC,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;;AAEA,IAAI,qBAAqB,EAAE,cAAc,EAAE;AAC3C,KAAK,gBAAgB,EAAE;AACvB,SAAS,YAAY,EAAE,gBAAgB,EAAE,6BAA6B,EAAE,YAAY,EAAE;AACtF,kBAAkB,6BAA6B,EAAE;;AAEjD,0BAA0B;AAC1B;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,yDAAmU;EACnU,aAAa;EACb,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB,kBAAkB,EAAE;AACzC","sourcesContent":[":root {\n  --black: #080808;\n  --deep: #0d0d0d;\n  --panel: #111111;\n  --panel2: #141414;\n  --border: rgba(255, 255, 255, 0.07);\n  --gold: #c9a96e;\n  --gold-light: #e8c98a;\n  --gold-dim: rgba(201, 169, 110, 0.15);\n  --white: #f5f0e8;\n  --muted: rgba(245, 240, 232, 0.45);\n  --font-display: 'Cormorant Garamond', serif;\n  --font-body: 'Syne', sans-serif;\n}\n\n*, *::before, *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  background: var(--black);\n  color: var(--white);\n  font-family: var(--font-body);\n  overflow-x: hidden;\n  cursor: none;\n}\n\na { text-decoration: none; color: inherit; }\nul { list-style: none; }\nbutton { border: none; background: none; font-family: var(--font-body); cursor: none; }\ninput, textarea { font-family: var(--font-body); }\n\n/* Noise texture overlay */\nbody::before {\n  content: '';\n  position: fixed;\n  inset: 0;\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E\");\n  opacity: 0.38;\n  pointer-events: none;\n  z-index: 9000;\n}\n\n.section-wrapper {\n  padding: 130px 80px;\n  position: relative;\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 90px;\n}\n\n.section-num {\n  font-family: var(--font-display);\n  font-size: 13px;\n  color: var(--gold);\n  opacity: 0.7;\n  letter-spacing: 0.1em;\n}\n\n.section-line {\n  width: 50px;\n  height: 1px;\n  background: var(--gold);\n  opacity: 0.3;\n}\n\n.section-title {\n  font-family: var(--font-display);\n  font-size: clamp(38px, 5vw, 68px);\n  font-weight: 300;\n  letter-spacing: -0.02em;\n  line-height: 1;\n}\n\n.section-title em {\n  font-style: italic;\n  color: var(--gold);\n}\n\n@media (max-width: 900px) {\n  .section-wrapper { padding: 90px 24px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
